// Little Ounce: подарки в корзине и полоска «до подарка».
// Автоматические скидки Shopify делают подарок бесплатным, только если он лежит в корзине. Этот скрипт кладёт его сам:
// наклейки по месяцам, когда в корзине весы (или набор с весами); набор щёток, когда корзина от $150.
// Главный приём: когда тема отправляет «в корзину» для весов, подарок добавляется ПЕРЕД её запросом. Тогда тема сама
// рисует корзину уже с подарком, и обновлять её вручную не нужно. Пока условие выполняется, подарок в корзине держится.
// Диагностика: открыть любую страницу с ?lo_debug=1, внизу появится чёрная панель с журналом.
// Настройки приходят из layout/theme.liquid в window.LO_CART. На живой витрине не проверен (09.10.2026): она под паролем.
(function () {
  var C = window.LO_CART;
  if (!C || window.__loCart) return;
  window.__loCart = true;
  var GIFT = '_gift', orig = window.fetch, cache = null, busy = false, timer = 0, justAdded = false;
  var LOG = [], DEBUG = /[?&]lo_debug=1/.test(location.search) || (function () { try { return sessionStorage.getItem('lo_debug') === '1'; } catch (e) { return false; } })();
  function log() {
    var line = [].slice.call(arguments).map(function (a) { return typeof a === 'string' ? a : JSON.stringify(a); }).join(' ');
    LOG.push(new Date().toISOString().slice(11, 19) + ' ' + line);
    if (!DEBUG) return;
    var el = document.getElementById('lo-debug');
    if (!el) {
      el = document.createElement('pre'); el.id = 'lo-debug';
      el.style.cssText = 'position:fixed;left:8px;right:8px;bottom:8px;max-height:46vh;overflow:auto;z-index:2147483647;background:#111;color:#9f9;font:11px/1.4 monospace;padding:10px;border-radius:8px;white-space:pre-wrap;margin:0';
      (document.body || document.documentElement).appendChild(el);
    }
    el.textContent = 'Little Ounce cart debug\n' + LOG.join('\n');
  }
  if (DEBUG) { try { sessionStorage.setItem('lo_debug', '1'); Object.keys(sessionStorage).forEach(function (k) { if (k.indexOf('lo_gift_') === 0) sessionStorage.removeItem(k); }); } catch (e) {} }
  log('script loaded, config', C);

  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function key(g) { return 'lo_gift_' + g.variant; }
  function json(url, body) {
    var o = { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' };
    if (body) { o.method = 'POST'; o.headers['Content-Type'] = 'application/json'; o.body = JSON.stringify(body); }
    return orig.call(window, url, o).then(function (r) { log(body ? 'POST' : 'GET', url, '->', r.status); if (!r.ok) return r.text().then(function (t) { log('  error body', t.slice(0, 200)); throw new Error('cart ' + r.status); }); return r.json(); });
  }
  function getCart() { return json('/cart.js').then(function (c) { cache = c; log('cart: total', c.total_price, 'items', (c.items || []).map(function (i) { return i.product_id + '/' + i.variant_id + ' x' + i.quantity; })); return c; }); }
  function line(cart, g) { return (cart.items || []).filter(function (i) { return i.variant_id === g.variant; })[0]; }
  function hasScale(cart) { return (cart.items || []).some(function (i) { return C.scaleProducts.indexOf(i.product_id) >= 0; }); }
  function addGift(g) {
    var props = {}; props[GIFT] = g.label;
    return json('/cart/add.js', { items: [{ id: g.variant, quantity: 1, properties: props }] }).then(function () { store(key(g), 'added'); cache = null; return true; });
  }
  function money(cents) { return '$' + (cents / 100).toFixed(cents % 100 ? 2 : 0); }

  // Какие варианты кладёт в корзину запрос темы (FormData, строка формы или JSON).
  function idsFromBody(body) {
    var ids = [];
    try {
      if (!body) return ids;
      if (typeof FormData !== 'undefined' && body instanceof FormData) { body.forEach(function (v, k) { if (k === 'id' || /^items\[\d+\]\[id\]$/.test(k)) ids.push(Number(v)); }); return ids; }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) { body.forEach(function (v, k) { if (k === 'id') ids.push(Number(v)); }); return ids; }
      if (typeof body === 'string') {
        if (body.charAt(0) === '{') { var d = JSON.parse(body); (d.items || [d]).forEach(function (i) { if (i && i.id) ids.push(Number(i.id)); }); }
        else new URLSearchParams(body).forEach(function (v, k) { if (k === 'id') ids.push(Number(v)); });
      }
    } catch (e) {}
    return ids;
  }

  // Перед запросом темы «в корзину»: если кладут весы, сначала кладём подарок.
  function before(ids) {
    var g = C.gifts.filter(function (x) { return x.when === 'scale'; })[0];
    log('theme adds variants', ids, 'scale among them:', ids.some(function (id) { return C.scaleVariants.indexOf(id) >= 0; }));
    if (!g) return Promise.resolve();
    if (!ids.some(function (id) { return C.scaleVariants.indexOf(id) >= 0; })) return Promise.resolve();
    return (cache ? Promise.resolve(cache) : getCart()).then(function (cart) {
      if (line(cart, g)) return;
      return addGift(g);
    }).catch(function (e) { log('before() failed', String(e)); });
  }

  // После любого изменения корзины: досыпать или убрать подарки, обновить полоску.
  function after() {
    if (busy) return;
    busy = true;
    getCart().then(function (cart) {
      var chain = Promise.resolve(false), scale = hasScale(cart);
      C.gifts.forEach(function (g) {
        var l = line(cart, g), isGift = !!(l && l.properties && l.properties[GIFT]);
        var due = g.when === 'scale' ? scale : cart.total_price - (isGift ? l.final_line_price : 0) >= C.stickersFrom;
        log('gift', g.when, 'due:', due, 'in cart:', !!l, 'as gift:', isGift);
        if (due && !l) {
          chain = chain.then(function () { return addGift(g); });
        } else if (!due && isGift) {
          store(key(g), '');
          chain = chain.then(function () { return json('/cart/change.js', { id: l.key, quantity: 0 }).then(function () { cache = null; return true; }); });
        }
      });
      return chain.then(function (did) { if (did) return refresh(); bar(cart); if (justAdded) toast(cart); justAdded = false; });
    }).catch(function (e) { log('after() failed', String(e)); }).then(function () { busy = false; });
  }

  // Корзина изменилась не запросом темы: перерисовать её блоки.
  function refresh() {
    if (location.pathname.indexOf('/cart') === 0) { location.reload(); return; }
    var nodes = [].slice.call(document.querySelectorAll('cart-items-component'));
    nodes.forEach(function (el) {
      var sec = el.closest('.shopify-section'), id = sec && sec.id.replace('shopify-section-', '');
      if (!id) return;
      orig.call(window, location.pathname + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html'), fresh = doc.querySelector('cart-items-component');
        if (fresh) el.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    });
    getCart().then(function (c) { bar(c); if (justAdded) toast(c); justAdded = false; }).catch(function () {});
  }

  // Сообщение «до бесплатной доставки осталось $…» в трёх местах: полоска в корзине (и в выезжающей, и на странице /cart),
  // верхняя строка сайта, всплывающая плашка после добавления товара.
  function message(total) {
    var ship = C.freeShipping, top = C.stickersFrom;
    if (!total) return null;
    if (total < ship) return 'You are ' + money(ship - total) + ' away from free shipping';
    if (total < top) return 'Free shipping unlocked. ' + money(top - total) + ' more for free scratch mittens';
    return 'Free shipping and free scratch mittens are yours';
  }
  function bar(cart) {
    var total = cart.total_price, text = message(total);
    var hosts = [].slice.call(document.querySelectorAll('cart-items-component'));
    if (!hosts.length && location.pathname.indexOf('/cart') === 0) { var m = document.querySelector('main'); if (m) hosts = [m]; }
    hosts.forEach(function (host) {
      var el = host.querySelector(':scope > .lo-cartbar');
      if (!text) { if (el) el.remove(); return; }
      if (!el) {
        el = document.createElement('div'); el.className = 'lo-cartbar';
        el.innerHTML = '<div class="lo-cartbar__text"></div><div class="lo-cartbar__track"><div class="lo-cartbar__fill"></div></div>';
        host.insertBefore(el, host.firstChild);
      }
      el.querySelector('.lo-cartbar__text').textContent = text + '.';
      el.querySelector('.lo-cartbar__fill').style.width = Math.min(100, Math.round(total / C.stickersFrom * 100)) + '%';
    });
    [].slice.call(document.querySelectorAll('.announcement-bar__text')).forEach(function (el) {
      if (el.dataset.loOriginal === undefined) el.dataset.loOriginal = el.textContent;
      el.textContent = text || el.dataset.loOriginal;
    });
    log('bar:', text || '(empty cart, default announcement)', 'hosts', hosts.length);
  }
  var toastTimer = 0;
  function toast(cart) {
    var text = message(cart.total_price);
    if (!text || document.querySelector('dialog[open] cart-items-component')) return;   // корзина уже открыта, там есть полоска
    var el = document.querySelector('.lo-toast');
    if (!el) { el = document.createElement('div'); el.className = 'lo-toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = text + '.';
    requestAnimationFrame(function () { el.classList.add('is-on'); });
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 4500);
  }

  window.fetch = function (input, init) {
    var self = this, args = arguments, url = '';
    try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
    var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url), isCart = /\/cart\/(add|change|update|clear)/.test(url);
    if (!isCart) return orig.apply(self, args);
    log('theme request', url);
    var pre = isAdd ? before(idsFromBody(init && init.body)) : Promise.resolve();
    return pre.then(function () { return orig.apply(self, args); }).then(function (res) {
      cache = null; if (isAdd) justAdded = true; clearTimeout(timer); timer = setTimeout(after, 600);
      return res;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', after); else after();
})();
